/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from "./vuetify";
import pinia from "../store";
import router from "../router";
import { installApollo } from "./apollo";

// Types
import type { App } from "vue";

export function registerPlugins(app: App) {
  app.use(pinia).use(vuetify).use(router);
  installApollo(app);
}
